
import { Card } from "@/components/ui/card";

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section with Image */}
      <div className="relative h-[300px] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85"
          alt="Legal documents on desk"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
          <h1 className="text-4xl font-bold text-white">Terms of Use</h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Card className="p-8 space-y-8 bg-white shadow-lg">
          <section>
            <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700">
              By accessing and using the Dynamico application, you agree to be bound by these Terms of Use. If you do not agree with these terms, please do not use the application.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">2. Registration</h2>
            <p className="text-gray-700">
              To use Dynamico, you may need to register and provide certain information, including a username, password, and email address.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">3. Privacy</h2>
            <p className="text-gray-700">
              Your privacy is important to us. Please review our Privacy Policy, which explains how we handle your personal information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">4. User Conduct</h2>
            <p className="text-gray-700">
              You agree to use Dynamico responsibly and to refrain from using the application for any unlawful purpose.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">5. Content</h2>
            <p className="text-gray-700">
              You are responsible for all content you upload, post, email, transmit, or otherwise make available via Dynamico. You agree not to upload, post, email, transmit, or otherwise make available any content that is unlawful, harmful, threatening, abusive, harassing, tortious, defamatory, vulgar, obscene, libelous, invasive of another's privacy, hateful, or racially, ethnically, or otherwise objectionable.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">6. Intellectual Property</h2>
            <p className="text-gray-700">
              All content included in the Dynamico application, such as text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations, and software, is the property of Dynamico or its content suppliers and protected by international copyright laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">7. Termination</h2>
            <p className="text-gray-700">
              We may terminate or suspend your access to Dynamico without prior notice or liability for any reason whatsoever, including, without limitation, if you breach the Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">8. Changes to Terms</h2>
            <p className="text-gray-700">
              Dynamico reserves the right to modify these Terms of Use at any time. We will post any changes we make to our Terms of Use on this page.
            </p>
          </section>
        </Card>
      </div>
    </div>
  );
};

export default Terms;
